<ng-template #popContent>
  <ul *ngFor="let b of blocks">
    <li>
      <div *ngIf="blocks.length > 0;">
        <div>  {{b.name}}, {{b.farmName}} - {{b.varietyName}} </div>
      </div>
    </li>
  </ul>
  <div *ngIf="blocks.length < 1;">
    <div>All Blocks</div>
  </div>


</ng-template>
<ng-template #popTitle>Blocks</ng-template>

<!-- Stuff that shows always -->
<div [ngbPopover]="popContent" [popoverTitle]="popTitle"
  triggers="mouseenter:mouseleave">
  <div *ngIf="blocks.length > 0;">
    <div>
      {{this.blocks.length}}
      <i class="fa fa-info-circle" style="margin-top: 3px; margin-left: 2px;
        font-size: 80%; color: #474747;" aria-hidden="false"></i>
    </div>
  </div>
  <div *ngIf="blocks.length < 1;">
    <div>
      All
    </div>
  </div>
</div>
